<template>
  <modal :show-on-mount="true" :click-outside-to-close="false" :headerless="true"
         size="sm" modal-id="generic-error-modal">
    <template #body>
      <div class="text-center">
        <p v-html="errorMessage" />
      </div>
    </template>
  </modal>
</template>

<script>
import Modal from './modal'

export default {
  components: { Modal },

  props: {
    errorMessage: {
      type: String,
      required: true
    }
  }
}
</script>
